import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LocalizedToasterService } from 'app/core/toaster/localized-toaster.service';
import { Location } from '@angular/common';
import { MergeAccountDataService } from 'app/shared/services/merge-account-data-service';
import { Observable } from 'rxjs';
import { RouterService } from 'app/core/navigation';
import { tap } from 'rxjs/operators';

import { UserInfoSettings } from 'app/shared/models/user-info-settings.model';
import { TranslationService } from 'app/core/internationalization/translation.service';

@Component({
    selector: 'kh-merge-teacher-send-email',
    styleUrls: ['./merge-teacher-send-email.component.less'],
    templateUrl: './merge-teacher-send-email.component.html',
    standalone: false
})
export class MergeTeacherSendEmailComponent implements OnInit {

  public settingsInfo$: Observable<UserInfoSettings> | undefined = undefined;

  public targetEmail = '';
  public targetDisplayName = '';

  private successTitle = '';
  private successMessage = '';

  public isEmailSent = false;

  public constructor(
    private readonly router: RouterService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly accountSettingsDataService: AccountSettingsDataService,
    private readonly toaster: LocalizedToasterService,
    private readonly location: Location,
    private readonly mergeAccountDataService: MergeAccountDataService,
    private readonly _translationService: TranslationService
  ) { }

  public ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    this.targetEmail = queryParams.get('email') as string;
    this.targetDisplayName = queryParams.get('displayName') as string;

    this.successTitle = this._translationService.instant('MERGE_TEACHER_SEND_EMAIL.AUTHENTICATION_EMAIL_SENT');
    this.successMessage = this._translationService.instant('MERGE_TEACHER_SEND_EMAIL.WEVE_SENT_A_LINK_TO', { email: this.targetEmail });

    this.settingsInfo$ = this.accountSettingsDataService.getSettingsInfo();
  }

  public continue(): void {
    this.mergeAccountDataService.sendMergeAccountEmail(this.targetEmail)
      .pipe(
        tap( () => {
          this.toaster.success(this.successTitle, this.successMessage);
          this.isEmailSent = true;
        })
      )
      .subscribe();
  }

  public backButton(): void {
    this.location.back();
  }
}
